import { useDispatch } from 'react-redux';
import { useQueryClient } from 'react-query';
import * as actions from '@/actions';

// initialize all client side states and clear all server side query cache data
export const useClearAllStates = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  function clearAllStates() {
    // The sort of 12 line and 13 line can't be reversed.
    // Otherwise, it will call APIs before logouted, and show unnecessary alert message
    dispatch(actions.initializeAllStates());
    queryClient.getQueryCache().clear();
  }

  return { clearAllStates };
};
